<template>
	<section :class="type">
		<slot />
	</section>
</template>


<script>
	export default {
		name: 'grid-container',
		props:{
			type: {
				type: String,
				default: 'grid-container',
			}
		}
	};
</script>


<style lang="stylus" scoped>
	@import '../styles.styl';
</style>


